import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";
import FooterSection from "./FooterSection";

export default function LegalLayout({ title, testId, children }) {
  return (
    <div data-testid={testId}>
      <header className="border-b border-white/10 bg-[#050B14]/90 backdrop-blur-xl sticky top-0 z-50">
        <div className="max-w-4xl mx-auto px-5 sm:px-8 py-4 flex items-center justify-between">
          <Link to="/" data-testid="legal-logo-link" className="flex items-center gap-2.5">
            <img
              src="/images/logo.png"
              alt="the coolpool company GmbH"
              className="h-9 w-auto notranslate"
              translate="no"
            />
          </Link>
          <Link
            to="/"
            data-testid="legal-back-home-link"
            className="inline-flex items-center gap-2 text-sm text-slate-300 hover:text-cyan-300 transition-colors"
          >
            <ArrowLeft className="w-4 h-4" /> Zurück zur Startseite
          </Link>
        </div>
      </header>
      <motion.main
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
        className="max-w-4xl mx-auto px-5 sm:px-8 py-16 sm:py-20"
      >
        <h1 className="font-medium tracking-tight text-4xl sm:text-5xl text-white">{title}</h1>
        <div className="mt-10 legal-content">{children}</div>
      </motion.main>
      <FooterSection />
    </div>
  );
}
